import { useMemo, useState } from 'react'
import { Popover } from 'antd'
import { Icon } from '@iconify/react'

import { getCachedProjectSprintOptions } from './sprintOptionsCache'
import SprintPickerPanel from './SprintPickerPanel'

import epicStyles from '../epicSelector/epicSelector.module.css'
import sprintStyles from './sprintSelector.module.css'

export {
    mapSprintListToOptions,
    getSprintDisplayOptionFromTask,
} from './sprintUtils'
export { clearProjectSprintOptionsCache } from './sprintOptionsCache'
export { default as SprintPickerPanel } from './SprintPickerPanel'

const SprintSelector = ({
    projectId,
    value,
    onChange,
    options: controlledOptions,
    displayOption,
    placeholder = 'Select sprint',
    disabled = false,
    enabled = true,
    compact = false,
    className,
}) => {
    const [visible, setVisible] = useState(false)

    const isControlled = Array.isArray(controlledOptions)

    const selectedItem = useMemo(() => {
        if (value == null || value === '') return null
        if (
            displayOption &&
            displayOption.value != null &&
            String(displayOption.value) === String(value)
        ) {
            return displayOption
        }
        if (isControlled) {
            const fromControlled =
                controlledOptions.find(
                    (item) => String(item.value) === String(value)
                ) || null
            if (fromControlled) return fromControlled
        }
        const cached = getCachedProjectSprintOptions(projectId)
        if (cached?.length) {
            return (
                cached.find((item) => String(item.value) === String(value)) ||
                null
            )
        }
        return null
    }, [value, displayOption, projectId, isControlled, controlledOptions])

    const handleSelect = (sprintId) => {
        onChange?.(sprintId)
        setVisible(false)
    }

    const panelContent = (
        <SprintPickerPanel
            active={visible}
            projectId={projectId}
            value={value}
            onChange={handleSelect}
            options={controlledOptions}
            placeholder={placeholder}
            disabled={disabled}
            enabled={enabled}
        />
    )

    return (
        <Popover
            content={panelContent}
            trigger="click"
            placement="bottomLeft"
            open={disabled ? false : visible}
            onOpenChange={(open) => {
                if (!disabled) setVisible(open)
            }}
            arrow={false}
            styles={{
                root: { paddingTop: 4 },
                body: {
                    padding: 0,
                    background: 'transparent',
                    boxShadow: 'none',
                },
            }}
            getPopupContainer={() => document.body}
        >
            <button
                type="button"
                className={[
                    epicStyles.trigger,
                    compact ? sprintStyles.triggerCompact : '',
                    className,
                ]
                    .filter(Boolean)
                    .join(' ')}
                disabled={disabled}
                aria-haspopup="listbox"
                aria-expanded={visible}
            >
                <span
                    className={
                        compact
                            ? sprintStyles.triggerInner
                            : epicStyles.triggerInner
                    }
                >
                    {selectedItem ? (
                        <span className={epicStyles.triggerValue}>
                            <span
                                className={
                                    compact
                                        ? sprintStyles.triggerTitleCompact
                                        : epicStyles.triggerTitle
                                }
                            >
                                {selectedItem.label}
                            </span>
                        </span>
                    ) : (
                        <span
                            className={
                                compact
                                    ? sprintStyles.triggerPlaceholderCompact
                                    : epicStyles.triggerPlaceholder
                            }
                        >
                            {placeholder}
                        </span>
                    )}
                    {!compact ? (
                        <Icon
                            icon={
                                visible ? 'mdi:chevron-up' : 'mdi:chevron-down'
                            }
                            width={20}
                            height={20}
                            className={epicStyles.chevron}
                        />
                    ) : null}
                </span>
            </button>
        </Popover>
    )
}

export default SprintSelector
